// extracted by mini-css-extract-plugin
export default {"module":"DiscoverDailyCarousel-module__module___s64Vw","fullWidth":"DiscoverDailyCarousel-module__fullWidth___tHmzm"};